import { api } from './apiClient';

export interface UserPayload {
  strategy: string;
  email: string;
  password: string;
}

export interface TokenPayload {
  iat: number;
  exp: number;
  aud: string;
  sub: string;
  jti: string;
}

export interface Authentication {
  strategy: string;
  payload: TokenPayload;
}

export interface User {
  id: number;
  email: string;
  googleId: string | null;
  auth0Id: string | null;
  companyId: string;
  firstName: string;
  lastName: string;
  avatarUrl?: string | null;
  lastLoggedIn: string | null;
  expiresAt: number | null;
  isActive: boolean;
  subscriptionPlan: string;
  companyName: string;
}

export interface AuthResult {
  accessToken: string;
  authentication: Authentication;
  user: User;
}

export const authService = {
  login: (data: UserPayload): Promise<AuthResult> => {
    return api.post('/authentication', data);
  },

  forgotPassword: (data: { email: string }): Promise<{ message: string }> => {
    return api.post<{ message: string }>('/users/resetPassword', data, {
      headers: { 'X-Service-Method': 'resetPassword' },
    });
  },

  completePasswordSetup: (token: string, password: string) => {
    return api.post<{ message: string }>(
      '/users/completePasswordSetup',
      { token, password },
      { headers: { 'X-Service-Method': 'completePasswordSetup' } }
    );
  },

  refresh: (accessToken: string): Promise<AuthResult> => {
    return api.post('/authentication', {
      strategy: 'refresh',
      accessToken,
    });
  },
};
